import React from 'react';
import NTMButton from "../Buttons";

import Papa from "papaparse";

export default class CSVExporter extends React.Component {

	state = {loading: false};

	downloadFile = async () => {
		if (this.state.loading) return;
		this.setState({loading: true});
		try {
			let {data, name} = this.props;
			if (typeof data === "function") data = await data();
			let csv = Papa.unparse(data, {delimiter: ";"});
			if (!name.endsWith(".csv")) name += ".csv";
			const element = document.createElement("a");
			const file = new Blob([csv], {type: 'text/plain'});
			element.href = URL.createObjectURL(file);
			element.download = name;
			document.body.appendChild(element); // Required for this to work in FireFox
			element.click();
		} catch (error) {
			if (this.props.onError) this.props.onError(error);
			else throw error;
		} finally {
			this.setState({loading: false});
		}
	};

	render() {
		return (
			<NTMButton primary disabled={this.state.loading} onClick={this.downloadFile}>
				<i className="fa fa-table" aria-hidden="true"/>
				{" "}
				{this.state.loading ? "Preparazione..." : this.props.title || "Scarica lista " + this.props.name}
			</NTMButton>
		);
	}
}